import React from 'react';

import { Block } from '../common/Block.jsx';
import { Builder, EditorContainer } from '../layout/Builder.jsx';
import { ButtonV1, ButtonV2, ButtonV3 } from './Button.jsx';
import * as Cell from '../common/Cell.jsx';
import { Animation } from '../common/Container.jsx';
import { default as Image, withHoverEffects } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';

function ShowCellContainer(props) {
    let data = props.data;
    if (data && data.show) {
        data = data.show;
    }
    let link;
    if (data) {
        link = Url.getLink('', `show/${data.showId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    }
    let content;
    let className = 'cell--whitelabel--show';
    switch (props.type) {
        case 'slideshow':
            className += ' slider__slide';
            let containerProps;
            if (props.onPageProps) {
                containerProps = props.onPageProps();
            } else if (props.contentConfig && props.contentConfig.desktop) {
                containerProps = props.contentConfig.desktop.page;
            }
            if (containerProps &&
                containerProps.config &&
                containerProps.config.block &&
                containerProps.config.block.useBackgroundImage &&
                data.image && data.image.id && data.image.id.length > 0) {
                const imageStyle = {};
                if (props.imageSize) {
                    imageStyle.backgroundImage = `url('${Image.url(data.image, props.imageSize, props.imageSize)}')`;
                }
                imageStyle.backgroundPosition = Block.backgroundPosition(containerProps.config.block.backgroundPosition);
                imageStyle.backgroundSize = containerProps.config.block.backgroundSize || 'cover';
                if (imageStyle.backgroundSize != 'cover') {
                    imageStyle.backgroundRepeat = Block.backgroundRepeat(containerProps.config.block);
                }
                content = (
                    <div
                        aria-label={data.title}
                        className="slider__slide--bg__image"
                        role="img"
                        style={imageStyle}
                        title={data.title} />
                )
            }
            break;
    }
    content = <Cell.Container {...props} className={className} link={link} useCellSpacer={false}>{content}</Cell.Container>
    switch (props.animation) {
        case '1':
            content = <Animation builder={props.builder}>{content}</Animation>
            break;
    }
    return content;
}

function ShowCellContainerParallax(props) {
    let data = props.data;
    if (data && data.show) {
        data = data.show;
    }
    let link;
    if (data) {
        link = Url.getLink('', `show/${data.showId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    }
    const containerStyle = { height: props.height };
    const contentConfig = props.contentConfig || {};
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    const handleBlockProps = (d) => {
        if (!d || !d.type) {
            return {};
        }
        switch (d.type.value) {
            case Name.Block.Show.Cell.DetailButtonV1:
            case Name.Block.Show.Cell.DetailButtonV2:
                return { url: link };
            default:
                return {};
        }
    };
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d, blockConfig, parentProps) => {
            const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Name.Block.Columns:
                    if (d.config && d.config.layout && d.config.layout.minHeight && d.config.layout.minHeight.value && d.config.layout.minHeight.value.length > 0) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.height = `${d.config.layout.minHeight.value}${d.config.layout.minHeight.unit}`;
                    }
                    break;
            }
            return blockProps;
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        } else if (data.image && props.imageSize) {
            containerStyle.backgroundImage = `url(${Image.url(data.image, props.imageSize, props.imageSize)})`
        }
    }
    const handleContent = (content, style) => {
        const contentClassName = 'parallax__content';
        if (!link || props.editor) {
            return <div className={contentClassName} style={style}>{content}</div>
        } else if (link) {
            return <a className={contentClassName} href={link} style={style}>{content}</a>
        }
        return content;
    }
    return (
        <EditorContainer
            {...props}
            blockPropsHandler={handleBlockProps}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className="parallax__slide cell--whitelabel cell--whitelabel--parallax"
            containerProps={contentConfig.desktop && contentConfig.desktop.page}
            inCell={true}
            style={containerStyle}
            updateBackgroundColor={false}
            onContainerProps={props.onPageProps}
            onContent={handleContent} />
    );
}

// #region SHOW DETAIL BUTTON (-- DEPRECATED Use `ShowDetailButtonV2` --)

function ShowDetailButtonV1Component(props) {
    return <ButtonV1.Component {...props} type="span" />;
}
const ShowDetailButtonV1 = { Component: ShowDetailButtonV1Component };

// #endregion SHOW DETAIL BUTTON

// #region SHOW DETAIL BUTTON V2

function ShowDetailButtonV2Component(props) {
    return <ButtonV2.Component {...props} type="span" />;
}
const ShowDetailButtonV2 = { Component: ShowDetailButtonV2Component };

// #endregion SHOW DETAIL BUTTON V2

// #region SHOW DETAIL BUTTON V3

function ShowDetailButtonV3Component(props) {
    return <ButtonV3.Component {...props} type="span" />;
}
const ShowDetailButtonV3 = { Component: ShowDetailButtonV3Component };

// #endregion SHOW DETAIL BUTTON V3

// #region SHOW IMAGE

function _ShowImageComponent(props) {
    const data = props.data || {};
    return (
        <Cell.Image
            {...props}
            className="show__card__img"
            image={data.image}
            imageData={{ alt: data.title, title: data.title }} />
    );
}
const ShowImageComponent = withHoverEffects(_ShowImageComponent, 'layout');
const ShowImage = { Component: ShowImageComponent };

// #endregion SHOW IMAGE

// #region SHOW META

function ShowMetaComponent(props) {
    const handleTokenReplacement = (keyword, options) => Token.parsing.show({ show: props.data }, keyword, options);
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const ShowMetaTokens = () => {
    return [
        { display: 'Title', token: Token.Title },
        Token.getWrappedTokenConfig('Date', Token.Date),
        Token.getWrappedTokenConfig('Opening Reception', Token.OpeningReception)
    ];
}
const ShowMeta = { Component: ShowMetaComponent, Tokens: ShowMetaTokens };

// #endregion SHOW META

export {
    ShowCellContainer,
    ShowCellContainerParallax,
    ShowDetailButtonV3,
    ShowImage,
    ShowMeta,

    // DEPRECATED
    ShowDetailButtonV1,
    ShowDetailButtonV2
}
